import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../models/user.model';
import { NgClass } from '@angular/common';
import { Project } from '../../models/project.module';
import { UserLogoComponent } from '../user-logo/user-logo.component';
import { MatTooltip } from '@angular/material/tooltip';


@Component({
  selector: 'frmg-user-logo-bundle',
  templateUrl: './user-logo-bundle.component.html',
  styleUrls: ['./user-logo-bundle.component.scss'],
  imports: [NgClass, UserLogoComponent, MatTooltip]
})
export class UserLogoBundleComponent implements OnInit {
  @Input() item: Project;
  currentUser: User;
  users: User[];
  tooltip: string;

  constructor() {
    this.currentUser = JSON.parse(localStorage.getItem('user')) as User;
  }


  ngOnInit(): void {
    this.users = this.item.shares.map((share) => share.shared_with_user);
    this.tooltip = this.getUsersWithAccess(this.item).map((user) => user.full_name || `${user.first_name} ${user.last_name}`).join(', ');
  }

  public getUsersWithAccess(project: Project): User[] {
    switch (this.currentUser.email) {
      case project.user.email:
        return [...this.users];
      default:
        return [project.user, ...this.users];
    }
  }

  public moreUsers(project: Project): User {
    if (project.shares.length == 3) {
      return project.shares[2].shared_with_user;
    } else {
      return {
        id: '0',
        teams: [],
        email: `+${project.shares.length - 2}`
      };
    }
  }
}
